import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getAllPartners, searchPartners, clearPartnerSearch } from 'redux/modules/partners';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import InfiniteScroll from 'react-infinite-scroller';
import { LeftNavLayout } from 'containers';
import { DataTable, PageHeader, Spinner } from 'components';
import PartnersFilterPanel from 'components/Admin/PartnersFilterPanel';
import * as styles from './Partners.scss';
import _ from 'lodash';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
var Partners = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    allPartners: state.partners.allPartners,
    gettingAllPartners: state.partners.gettingAllPartners,
    partnerSearchResults: state.partners.partnerSearchResults
  };
}, {
  getAllPartners: getAllPartners,
  searchPartners: searchPartners,
  clearPartnerSearch: clearPartnerSearch
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Partners, _Component);

  var _super = _createSuper(Partners);

  function Partners() {
    var _this;

    _classCallCheck(this, Partners);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      pageSize: 25,
      listOffset: 0,
      searchQuery: '',
      hasMorePartners: true,
      headerFields: [{
        name: 'ID',
        key: 'orgId',
        selected: true
      }, {
        name: 'Partner Name',
        key: 'name',
        selected: true
      }, {
        name: 'Owner',
        key: 'ownerFullName',
        selected: true
      }, {
        name: 'Email',
        key: 'email',
        selected: true
      }, {
        name: 'Partner Type',
        key: 'partnerType',
        selected: true
      }, {
        name: 'Start Date',
        key: 'createdAt',
        selected: false
      }, {
        name: 'Status',
        key: 'status',
        selected: false
      }, {
        name: 'Sales Rep',
        key: 'salesRepName',
        selected: false
      }]
    });

    _defineProperty(_assertThisInitialized(_this), "loadPage", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var results;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this.state.hasMorePartners || _this.props.gettingAllPartners)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              _context.next = 5;
              return _this.props.getAllPartners(_this.state.pageSize, _this.state.listOffset);

            case 5:
              results = _context.sent;

              _this.setState({
                listOffset: _this.state.listOffset + results.data.Organizations.length,
                hasMorePartners: results.data.Organizations.length === _this.state.pageSize
              });

              _context.next = 11;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "loadSearch", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var results;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _this.props.searchPartners(_this.state.searchQuery);

            case 3:
              results = _context2.sent;
              _context2.next = 8;
              break;

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 6]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleRowSelection", function (selectedRows) {
      browserHistory.push({
        pathname: "/global/partners/".concat(selectedRows.orgId)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "searchDidChange", function (query) {
      setTimeout(function () {
        return _this.loadSearch();
      }, 100);
    });

    return _this;
  }

  _createClass(Partners, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.allPartners && !this.props.allPartners.length) {
        this.loadPage();
      }
    }
  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin",
        wrapStyle: {
          padding: 36,
          display: 'flex',
          flexDirection: 'column',
          width: 'calc(100% - 183px)',
          overflowY: 'scroll'
        },
        appLayoutInnerStyle: {
          display: 'flex',
          flex: '1 1 auto',
          padding: 0,
          overflow: 'hidden',
          height: '100%'
        },
        rightPanel: /*#__PURE__*/React.createElement(PartnersFilterPanel, {
          columns: this.state.headerFields,
          onChange: function onChange(key, isChecked) {
            var fields = _toConsumableArray(_this2.state.headerFields);

            var idx = fields.findIndex(function (_ref3) {
              var k = _ref3.key;
              return k === key;
            });

            _.set(fields, "[".concat(idx, "].selected"), isChecked);

            _this2.setState({
              headerFields: fields
            });
          }
        })
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Partners List"
      }), /*#__PURE__*/React.createElement(InfiniteScroll, {
        loadMore: this.loadPage,
        hasMore: this.state.hasMorePartners && !this.props.gettingAllPartners,
        initialLoad: false,
        useWindow: false,
        threshold: 700
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Partners"
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.searchBar
      }, /*#__PURE__*/React.createElement(TextField, {
        placeholder: "Search Partners",
        value: this.state.searchQuery,
        name: "searchQuery",
        onChange: function onChange(e) {
          return _this2.setState({
            searchQuery: e.target.value
          });
        },
        onKeyPress: function onKeyPress(e) {
          if (e.key === 'Enter') {
            _this2.searchDidChange(_this2.state.searchQuery);
          }
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Search",
        onClick: function onClick() {
          return _this2.searchDidChange(_this2.state.searchQuery);
        },
        style: {
          marginLeft: 24
        }
      }), this.state.searchQuery && this.state.searchQuery.length > 0 && /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Clear",
        onClick: function onClick() {
          _this2.props.clearPartnerSearch();

          _this2.setState({
            searchQuery: ''
          });
        },
        style: {
          marginLeft: 24
        }
      })), /*#__PURE__*/React.createElement(DataTable, {
        stickyHeader: true,
        noRowClasses: true,
        firstColColored: true,
        headerFields: _toConsumableArray(this.state.headerFields).filter(function (f) {
          return f.selected;
        }).map(function (f) {
          return _objectSpread(_objectSpread({}, f), {}, {
            disableSort: true
          });
        }),
        data: this.props.partnerSearchResults && this.props.partnerSearchResults.length > 0 ? this.props.partnerSearchResults : this.props.allPartners,
        fixedHeader: true,
        height: 500,
        onRowSelection: this.handleRowSelection
      })));
    }
  }]);

  return Partners;
}(Component)) || _class);
export { Partners as default };